import { Avatar, Box, Typography } from '@material-ui/core';
import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { getTimeText } from '../../services/datetime';

interface IProps {
  avatar?: boolean;
  comment: IComment;
  onClickReply: () => void;
  reply: boolean;
}
const useStyles = makeStyles({
  avatar: {
    height: '28px',
    width: '28px',
  },
});
const CommentItem: React.FC<IProps> = ({
  avatar = false,
  comment,
  onClickReply,
  reply = true,
}) => {
  const { avatar: avatarStyle } = useStyles();
  return (
    <Box display='flex' width='100%'>
      {avatar && (
        <Box width='40px'>
          <Avatar src={comment.avatar} className={avatarStyle} />
        </Box>
      )}
      <Box width='100%'>
        <Box mb={1} width='100%'>
          <Typography variant='caption'>
            <Box
              component='span'
              color={'#81E6D9'}
              style={{ opacity: comment.author ? 1 : 0.5 }}
            >
              {comment.author ? comment.author : 'ไม่มีชื่อ'}
              &nbsp;({comment.uid.substring(0, 5)}xxx)
            </Box>
          </Typography>
        </Box>
        <Typography variant='body1'>{comment.content}</Typography>
        <Box my={1} display='flex' alignItems='center' flexWrap='wrap'>
          <Typography variant='caption'>
            <Box component='span' style={{ opacity: 0.5 }} mr={4}>
              {getTimeText(comment.createdAt)}
            </Box>
          </Typography>
          {reply && (
            <Box
              onClick={onClickReply}
              style={{ cursor: 'pointer' }}
              flexGrow={1}
            >
              <Typography variant='caption'>
                <Box component='span' color='#81E6D9'>
                  ตอบกลับ
                </Box>
              </Typography>
            </Box>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default CommentItem;
